module.exports = __webpack_public_path__ + "img/Logo2.8b89f615.jpg";